import { DashboardConfig } from '../../../common/components/dashboards/types';
import { Languages } from '../../../constants';
import { DataTypes, EmployeeDataFields } from '../../../types';
import { getTdHoldingsHumanCapitalDbPageConfigs } from './td-holdings-human-capital-db-page-configs';

const dashboardId = 'td_holdings_human_capital';

export const TdHoldingsHumanCapitalDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Human Capital Management',
    [Languages.JA]: '人的資本開示',
  },
  enabled: true,
  dashboardOptions: {
    allowedFilterFields: [
      {
        dataType: DataTypes.EMPLOYEE,
        dataField: EmployeeDataFields.CUSTOM_FIELD_1,
      },
      {
        dataType: DataTypes.EMPLOYEE,
        dataField: EmployeeDataFields.CUSTOM_FIELD_5,
      },
      {
        dataType: DataTypes.EMPLOYEE,
        dataField: EmployeeDataFields.EMPLOYMENT_REGULARITY,
      },
      {
        dataType: DataTypes.EMPLOYEE,
        dataField: EmployeeDataFields.EMPLOYMENT_TYPE,
      },
      {
        dataType: DataTypes.EMPLOYEE,
        dataField: EmployeeDataFields.FUNCTION,
      },
    ],
  },
  pages: getTdHoldingsHumanCapitalDbPageConfigs(dashboardId),
};
